import React from 'react'

import { Select, File, Checkbox } from '@peracto/peracto-editor-ui'

export const backgroundPositionOptions = [
    { label: 'Centre', value: 'center' },
    { label: 'Top', value: 'center top' },
    { label: 'Bottom', value: 'center bottom' },
    { label: 'Left', value: 'left center' },
    { label: 'Right', value: 'right center' },
]

export const backgroundSizeOptions = [
    { label: 'Initial', value: 'initial' },
    { label: 'Cover', value: 'cover' },
    { label: 'Contain', value: 'contain' },
]

export const backgroundRepeatOptions = [
    { label: 'None', value: 'no-repeat' },
    { label: 'Both', value: 'both' },
    { label: 'Horizontal', value: 'repeat-x' },
    { label: 'Vertical', value: 'repeat-y' },
]

const BackgroundImageOptions = ({ settings, setSettings, canContainBackground = false }) => {
    return (
        <div data-testid={`background-image-options-section`}>
            <div className="!flex !justify-between !mt-2">
                <label>Background Image Options</label>
            </div>

            <File
                label="Image"
                value={settings.backgroundImage}
                showThumbnail={false}
                onChange={value =>
                    setSettings({
                        ...settings,
                        backgroundImage: value,
                    })
                }
                data-testid="background-image"
            />

            {settings?.backgroundImage?.length > 0 && (
                <>
                    <Select
                        label="Background Position"
                        options={backgroundPositionOptions}
                        value={settings.backgroundPosition}
                        onChange={({ value }) => {
                            setSettings({
                                ...settings,
                                backgroundPosition: value,
                            })
                        }}
                    />

                    <Select
                        label="Background Size"
                        options={backgroundSizeOptions}
                        value={settings.backgroundSize}
                        onChange={({ value }) =>
                            setSettings({
                                ...settings,
                                backgroundSize: value,
                            })
                        }
                    />

                    <Select
                        label="Background Repeat"
                        options={backgroundRepeatOptions}
                        value={settings.backgroundRepeat}
                        onChange={({ value }) =>
                            setSettings({
                                ...settings,
                                backgroundRepeat: value,
                            })
                        }
                    />

                    {canContainBackground && (
                        <Checkbox
                            label="Contain Background"
                            checked={settings.backgroundContain}
                            onChange={e =>
                                setSettings({ ...settings, backgroundContain: e.target.checked })
                            }
                            help="Limit the width of the background to the storefront page container's width"
                        />
                    )}
                </>
            )}
        </div>
    )
}

export default BackgroundImageOptions
